// src/App.js
import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Doctor from './pages/Doctor';
import DoctorProfile from './pages/DoctorProfile';
import MedicalSpecialty from './pages/MedicalSpecialty';
import Orthopedic from './pages/Orthopedic';
import CardiacSciences from './pages/CardiacSciences';
import Overview from './pages/Overview';
import VisionAndMission from './pages/VisionAndMission';
import PatientPortal from './pages/PatientPortal';
import Appointment from './pages/Appointment';
import Prescriptions from './pages/Prescriptions';
import LabReport from './pages/LabReport';
import NewAppointment from './pages/NewAppointment';
import Infrastructure from './pages/Infrastructure';
import ContactUs from './pages/ContactUs';
import Career from './pages/Career';
import AyushmanBharat from './pages/AyushmanBharat';


// Import slick-carousel styles here 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import OpdSchedule from './pages/OpdSchedule';
import Quality from './pages/Quality';
import InsuranceAwardsAchievements from './pages/InsuranceAwardsAchievements';
import MediaandInformation from './pages/MediaandInformation';
import TraumaCenterFacility from './pages/TraumaCenterFacility';
import BedAvailability from './pages/bed-availability/BedAvailability';
import DeathCertificateForm from './pages/forms/DeathCertificateForm';
import TreatmentEstimateForm from './pages/forms/TreatmentEstimateForm';
import LifeInsuranceClaimForm from './pages/forms/LifeInsuranceClaimForm';
import MedicalCertificateForm from './pages/forms/MedicalCertificateForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AppPrivacyPolicy from './pages/AppPrivacyPolicy';

function App() {
    return (

        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route path="/doctor" element={<Doctor />} /> */}
                <Route path="/doctor-profile/:id" element={<DoctorProfile />} />
                <Route path="/medical-specialty" element={<MedicalSpecialty />} />
                <Route path="/orthopedic" element={<Orthopedic />} />
                <Route path="/cardiac-sciences" element={<CardiacSciences />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/vision-mission" element={<VisionAndMission />} />
                <Route path="/patient-portal" element={<PatientPortal />} />
                <Route path="/appointment" element={<Appointment />} />
                <Route path="/new-appointment" element={<NewAppointment />} />
                <Route path="/prescriptions" element={<Prescriptions />} />
                <Route path="/lab-report" element={<LabReport />} />
                <Route path="/infrastructure" element={<Infrastructure />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/career" element={<Career />} />
                <Route path="/ayushman-bharat" element={<AyushmanBharat />} />
                <Route path="/opd-schedule" element={<OpdSchedule />} />
                <Route path="/quality" element={<Quality />} />
                <Route path="/insurance-awards-achievements" element={<InsuranceAwardsAchievements />} />
                <Route path="/media-and-information" element={<MediaandInformation />} />
                <Route path="/trauma/center/facility" element={<TraumaCenterFacility />} />
                
                <Route path='/app-privacy-policy' element={<AppPrivacyPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/bed-availability" element={<BedAvailability />} />
                <Route path="/forms/death-certificate" element={<DeathCertificateForm />} />
                <Route path="/forms/treatment-estimate" element={<TreatmentEstimateForm />} />
                <Route path="/forms/life-insurance-claim" element={<LifeInsuranceClaimForm />} />
                <Route path="/forms/medical-certificate" element={<MedicalCertificateForm />} />
                <Route path="/forms/medical-certificate" element={<MedicalCertificateForm />} />

            </Routes>
        </Router>
    );
}

export default App;
